module.exports = __webpack_public_path__ + "img/diamonds-1.657be9e.png";